import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=4b0c9c2e&scoped=true&"
var script = {}
import style0 from "./AppModal.vue?vue&type=style&index=0&id=4b0c9c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c9c2e",
  null
  
)

export default component.exports